import React from 'react';
import { Loader2, Send, Paperclip } from 'lucide-react';

export function SupportReplyComposer({
  reply,
  onReplyChange,
  onSend,
  onAttachFiles,
  sending,
  attachUploading,
  attachErr,
  replyErr,
  disabled,
  theme = 'b2c',
  placeholder = 'Reply to support…',
}) {
  const sendBtnClass = theme === 'agent'
    ? 'bg-gradient-to-r from-teal-500 to-cyan-600 hover:opacity-90'
    : 'bg-gradient-to-r from-orange-500 to-red-500 hover:opacity-90';

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!disabled && !sending && reply.trim()) onSend();
    }
  };

  return (
    <div className="p-3 border-t border-gray-200 bg-gray-50 space-y-2 sticky bottom-0 z-10">
      {(attachErr || replyErr) && (
        <div className="text-xs text-red-600" data-testid="reply-error">
          {replyErr || attachErr}
        </div>
      )}
      <div className="flex flex-wrap items-center gap-2">
        <label className={`text-xs cursor-pointer inline-flex items-center gap-1 border border-gray-300 rounded-lg px-2 py-1 bg-white hover:bg-gray-50 ${
          theme === 'agent' ? 'text-teal-700' : 'text-blue-700'
        }`}>
          <Paperclip className="w-3.5 h-3.5" />
          {attachUploading ? 'Uploading…' : 'Attach files'}
          <input
            type="file"
            multiple
            accept=".png,.jpg,.jpeg,.pdf,.webp"
            className="hidden"
            onChange={onAttachFiles}
            disabled={attachUploading || disabled}
            data-testid="ticket-attach-input"
          />
        </label>
      </div>
      <div className="flex gap-2">
        <textarea
          data-testid="my-reply-textarea"
          value={reply}
          onChange={(e) => onReplyChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          rows={2}
          disabled={disabled}
          className="flex-1 text-sm border border-gray-300 rounded-lg px-3 py-2 resize-none"
        />
        <button
          type="button"
          data-testid="my-send-reply-btn"
          onClick={onSend}
          disabled={disabled || sending || !reply.trim()}
          className={`self-end text-white px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2 disabled:opacity-50 ${sendBtnClass}`}
        >
          {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
          Send
        </button>
      </div>
    </div>
  );
}

export default SupportReplyComposer;
